import axios from "axios";
import gerarChaveAPI from "./gerarChaveAPI.js";

const cadastrarUsuario = async function (bodyreq) {
  console.log("entrou cadastrarUsuario")
  try {
      const numeroChave = await gerarChaveAPI()
      const url = `${process.env.VUE_APP_ALIANCA_PROTHEUS}/quallogin?api-key=${process.env.VUE_APP_ALIANCA_PROTHEUS_KEY}`;
      const headers = {
        headers: {
          "Token": process.env.VUE_APP_ALIANCA_PROTHEUS_TOKEN_KEY, 
          "Chave": numeroChave 
        }
      }
      const { data } = await axios.post(url, bodyreq, headers);

      return data;
  } catch (e) {
    console.log(e)
    throw e;
  }
};

export default cadastrarUsuario;
